var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6803 18.3198C79.6736 16.3061 77.2891 14.7084 74.6636 13.6182C72.0381 12.528 69.2232 11.9668 66.3803 11.9668C63.5375 11.9668 60.7226 12.528 58.0971 13.6182C55.4715 14.7084 53.0871 16.3061 51.0803 18.3198L48.0003 21.4398L44.9203 18.3198C42.9136 16.3061 40.5291 14.7084 37.9036 13.6182C35.2781 12.528 32.4632 11.9668 29.6203 11.9668C26.7775 11.9668 23.9626 12.528 21.3371 13.6182C18.7115 14.7084 16.3271 16.3061 14.3203 18.3198C5.84035 26.7998 5.32034 41.1198 16.0003 51.9998L48.0003 83.9998L80.0003 51.9998C90.6803 41.1198 90.1603 26.7998 81.6803 18.3198Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeartFilled;